import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = {
  for: "course",
  class: "form-label"
}
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = {
  for: "category",
  class: "form-label"
}
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = {
  for: "subject",
  class: "form-label"
}
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "form-error-text" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = {
  for: "body",
  class: "form-label"
}
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "form-error-text" }
const _hoisted_13 = { class: "pt-4 pb-2 flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_form_select = _resolveComponent("base-form-select")!

  return (_openBlock(), _createElementBlock("form", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.t('contact_faq.course')), 1),
      _createVNode(_component_base_form_select, {
        class: "mb-1",
        selectedVal: _ctx.contact_course_id,
        "onUpdate:selectedVal": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contact_course_id) = $event)),
        options: _ctx.store.state.contact.course
      }, null, 8, ["selectedVal", "options"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.t('word.contents')), 1),
      _createVNode(_component_base_form_select, {
        class: "mb-1",
        selectedVal: _ctx.contact_category_id,
        "onUpdate:selectedVal": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contact_category_id) = $event)),
        options: _ctx.store.state.contact.category
      }, null, 8, ["selectedVal", "options"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.t('word.subject')), 1),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.subject) = $event)),
        id: "subject",
        name: "subject",
        type: "text",
        placeholder: _ctx.t('word.subject'),
        class: _normalizeClass(`form-input mb-1 ${_ctx.errors['subject'] ? 'border-red-500' : ''}`)
      }, null, 10, _hoisted_7), [
        [_vModelText, _ctx.subject]
      ]),
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.errors['subject']), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.t('word.body')), 1),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.body) = $event)),
        id: "body",
        name: "body",
        placeholder: _ctx.t('word.body'),
        class: _normalizeClass(`form-input mb-1 ${_ctx.errors['body'] ? 'border-red-500' : ''}`),
        rows: 5
      }, null, 10, _hoisted_11), [
        [_vModelText, _ctx.body]
      ]),
      _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.errors['body']), 1)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("button", {
        type: "button",
        class: "bg-blue-500 hover:bg-blue-400 text-white py-1.5 px-4 rounded disabled:opacity-75 mr-2",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onContactConfirm()))
      }, "確認")
    ])
  ]))
}